// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"77":"f44c389b","531":"ce6158ab","836":"7f69a870"}[chunkId] + ".js";
};